import type { MediaLibraryCopyStatus } from "@dealer-center/ddc-pages-media-library-copy-fetch";
import { Alert } from "@dealer-center/core-components";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import styled from "styled-components";

const StyledResultsArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
`;

const StyledResultArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledResultHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const StyledResultPre = styled.pre`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 1rem;
`;

interface PagesAccountCopyUiResultsDisplayProps {
  error?: string;
  isPending: boolean;
  statusData?: MediaLibraryCopyStatus;
  selectedDealer?: string;
  targetAccountId: string;
  isFetching: boolean;
}

export const PagesAccountCopyUiResultsDisplay = ({
  error,
  isPending,
  statusData,
  selectedDealer,
  targetAccountId,
  isFetching
}: PagesAccountCopyUiResultsDisplayProps) => {
  if (error) {
    return (
      <StyledResultsArea>
        <StyledAlert role="alert" sx={{ marginBottom: "16px" }} type="error">
          {error}
        </StyledAlert>
      </StyledResultsArea>
    );
  }

  if (isPending) {
    return (
      <StyledResultsArea>
        <LoadingIndicator
          actionName={"Loading PagesAccountCopyUi"}
          data-testid={"PagesAccountCopyUiLoading"}
        />
      </StyledResultsArea>
    );
  }

  if (!statusData) {
    return null;
  }

  const successUrl = `https://apps.dealercenter.coxautoinc.com/promotions/as/${targetAccountId}/${targetAccountId}-admin/medialibrary3/index?lang=en_US`;

  const logLines = statusData.logLines
    .map((status, index) => `${index + 1}. ${status}`)
    .reverse()
    .join("<br />")
    .toString()
    .replace(/\n/g, "<br />");
  return (
    <StyledResultsArea>
      <StyledResultArea>
        <StyledResultHeader>Result</StyledResultHeader>
        <label>
          Copy {selectedDealer} to {targetAccountId}: {statusData?.status}
        </label>
        <a href={successUrl} rel="noreferrer" target="_blank">
          Go to Media Library
        </a>
        <StyledResultPre
          dangerouslySetInnerHTML={{
            __html: logLines || "No logs available"
          }}
        />
        {isFetching && (
          <LoadingIndicator
            actionName={"Fetching Status"}
            text="Updating Status..."
          />
        )}
      </StyledResultArea>
    </StyledResultsArea>
  );
};
